import gql from 'graphql-tag';

export const personFieldsFragment = gql`
    fragment personFields on Person {
        uuid
        firstName
        lastName
        watermark
        status
        title
        location
        path
        image
        authorImage
        isPublic
        isTeamMember
        bio
        shortBio
        department
        index
        updatedAt
        createdAt
        isVersion
    }
`;

export const peoplePaginationFragment = gql`
    fragment peoplePagination on PersonList {
        page
        limit
        total
        count
    }
`;
